<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <list/>
    </div>
  </div>
</template>

<script>
import List from '../../components/reports/invoiceItemsByPartner/List';

export default {
  components: {
    List,
  },
  data() {
    return {

    }
  },
  computed: {
  },
  async mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
</style>
